/** Draws a branded arcade brag card on a canvas and shares it via the
 * native share sheet (falls back to downloading the PNG). */
export async function shareArcadeCard({ title, value, sub }) {
  const c = document.createElement("canvas");
  c.width = 1080;
  c.height = 1080;
  const x = c.getContext("2d");

  x.fillStyle = "#0B0E14";
  x.fillRect(0, 0, 1080, 1080);
  x.fillStyle = "rgba(41,98,255,0.16)";
  for (let i = 40; i < 1080; i += 60) {
    for (let j = 40; j < 1080; j += 60) {
      x.beginPath();
      x.arc(i, j, 2, 0, 7);
      x.fill();
    }
  }
  const g = x.createRadialGradient(540, 500, 60, 540, 500, 430);
  g.addColorStop(0, "rgba(41,98,255,0.35)");
  g.addColorStop(1, "rgba(41,98,255,0)");
  x.fillStyle = g;
  x.fillRect(0, 80, 1080, 860);

  x.textAlign = "center";
  x.fillStyle = "#F7B731";
  x.font = "700 42px 'JetBrains Mono', monospace";
  x.fillText("VTS ARCADE — EARNINGS FLOOR", 540, 140);

  x.fillStyle = "#FFFFFF";
  x.font = "900 210px 'Sora', sans-serif";
  x.shadowColor = "rgba(41,98,255,0.8)";
  x.shadowBlur = 60;
  x.fillText(String(value), 540, 560);
  x.shadowBlur = 0;

  x.fillStyle = "#F7B731";
  x.font = "900 68px 'Sora', sans-serif";
  x.fillText(title, 540, 690);

  x.fillStyle = "rgba(255,255,255,0.6)";
  x.font = "500 36px 'JetBrains Mono', monospace";
  x.fillText(sub, 540, 760);

  x.strokeStyle = "rgba(247,183,49,0.5)";
  x.lineWidth = 3;
  x.strokeRect(60, 60, 960, 960);

  x.fillStyle = "rgba(255,255,255,0.45)";
  x.font = "500 34px 'JetBrains Mono', monospace";
  x.fillText(`play at ${window.location.host}`, 540, 980);

  const blob = await new Promise((r) => c.toBlob(r, "image/png"));
  const file = new File([blob], "vts-arcade-card.png", { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: "VTS Arcade", text: `${title} — ${sub}` });
      return "shared";
    } catch {
      return "cancelled";
    }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "vts-arcade-card.png";
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
  return "downloaded";
}
